export const sections=["ABOUT","SKILLS","EXPERIENCE","PROJECTS","CERTIFICATIONS"];